import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const endpoint = apiUrl + 'v2';

async function getWeighbridgeTicketList(filters = {}) {
  const user = getLoggedUser(); // Make sure you have this function
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
    params: filters // Add filters as query parameters
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/weighbridge-tickets`, config);
    return response;
  } catch (error) {
    console.error('Error fetching weighbridge tickets:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function exportWeighbridgeTickets (filters) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${endpoint}/weighbridge-tickets/excel/export`, {
            params: filters,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob',
        });
        
        // Check if response is actually a blob (Excel file)
        if (response.data instanceof Blob) {
            return response;
        } else {
            // If not a blob, try to parse as JSON
            const text = await new Response(response.data).text();
            try {
                const jsonData = JSON.parse(text);
                throw new Error(jsonData.message || 'Unknown error');
            } catch (e) {
                throw new Error('Failed to export report');
            }
        }
    } catch (error) {
        console.error('Error exporting weighbridge tickets:', error);
        
        // Provide better error message
        if (error.response) {
            // Server responded with error status
            if (error.response.status === 404) {
                throw new Error('No tickets found for the selected filters');
            }
            if (error.response.status === 422) {
                throw new Error('Invalid filter parameters');
            }
            if (error.response.data && error.response.data.message) {
                throw new Error(error.response.data.message);
            }
        }
        throw error;
    }
};

async function sendTransitReport(date = null) {
  const user = getLoggedUser();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  const payload = {};
  if (date) {
    payload.date = date;
  }

  try {
    const { data: response } = await axios.post(`${endpoint}/weighbridge-tickets/send-transit-report`, payload, config);
    return response;
  } catch (error) {
    console.error('Error sending transit report:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to send transit report',
      status: error.response?.status || 500,
      error: error,
    };
  }
}


export {getWeighbridgeTicketList , exportWeighbridgeTickets , sendTransitReport} ;
